const ChatBot = () => null;

export default ChatBot;